// @ts-nocheck
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Header } from "../components/Header";
import Home from "../pages/Home";
import Menu from "../pages/Menu";
import TermsOfService from "../pages/TermsOfService";
import PrivacyPolicy from "../pages/PrivacyPolicy";

/**
 * Every page opens at its top.
 *
 * Without this, walking from a home screen scrolled halfway down to the full menu lands
 * the guest in the middle of the new page - the router keeps the old offset. Keyed on
 * the path only, so the menu's own jump to a category (which changes just the query
 * string) still works, and it runs before that jump anyway.
 *
 * Both scrollers are reset: the window scrolls on a phone, while inside the desktop
 * phone frame it is #app-scroll that does.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const frame = document.getElementById("app-scroll");
        if (frame) frame.scrollTop = 0;
    }, [pathname]);

    return null;
};

const Navigation = () => {
    return (
        <BrowserRouter >
            <ScrollToTop />
            <Header />
            <div className="main-content"> {/* Adjusted top padding to match the smaller header */}
                <Routes>
                    <Route path="*" element={<Navigate to="/home" replace />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/menu" element={<Menu />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                </Routes>
            </div>
            {/* Each page renders its own Footer, so there is none here. */}
        </BrowserRouter>
    );
};

export default Navigation;
